module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-asa_trimmark.6ae13e98.png";